import createCachedSelector from 're-reselect';
import { initialFacilityViewState } from 'store/reducers/scheduleSlice/index.initialState';
import { generateViewKey } from 'store/reducers/scheduleSlice/index.utils';
import { IGlobalReduxStore } from 'store';

const getSchedule = (state: IGlobalReduxStore) => state.schedule;
const getSelectedFacilityId = (state: IGlobalReduxStore) => state.schedule.selectedFacilityId;

const scheduleFacilityViewStateSelector = createCachedSelector(
  getSelectedFacilityId,
  getSchedule,
  (selectedFacilityId, schedule) => {
    const facilityViewStateKey = generateViewKey(selectedFacilityId);
    if (!schedule[facilityViewStateKey]) return initialFacilityViewState;
    return schedule[facilityViewStateKey];
  },
)((state: IGlobalReduxStore) => {
  const selectedFacilityId = getSelectedFacilityId(state);
  const schedule = getSchedule(state);

  const facilityViewStateKey = generateViewKey(selectedFacilityId);
  if (!schedule[facilityViewStateKey]) return JSON.stringify(initialFacilityViewState);
  return JSON.stringify(schedule[facilityViewStateKey]);
});

export default scheduleFacilityViewStateSelector;
